{
  "actions": "アクション"
}
